<template>
  <div id="app">
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <ModalDenuncia :visible="showModal" :protocolo="protocolo" :empresa="empresa" />
    <main :style="{ backgroundColor: empresa.cor_site_clara }">
      <div>
        <p id="p1">
          Compliance
        </p>
        <p id="p2">
          Fazer uma nova denúncia
        </p>
      </div>

      <div class="box_general mb-0">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="style_label">Seu nome: <p class="opt_text">(Opcional)</p></label>
              <input type="text"
                class="form-control"
                v-model="obj.nome_denunciante"
              >
            </div>
          </div>
        </div>
        <div v-if="unidades.length > 0" class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="style_label">Unidade:</label>
              <v-select
                label="nome_unidade"
                v-model="obj.unidades_id"
                class="form-select"
                :reduce="unidades => unidades.id"
                :options="unidades"
                :searchable="true"
              >
              </v-select> 
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="style_label">Tipo de Denúncia:</label>
              <v-select
                label="tipo"
                v-model="obj.tipo_denuncia"
                class="form-select"
                :reduce="tipos_denuncia => tipos_denuncia.id"
                :options="tipos_denuncia"
                :searchable="true"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="style_label">Arquivo: <p class="opt_text">(Opcional)</p></label>
              <input
                  @change="changeFile"
                  type="file"
                  class="flex"
                />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="style_label">Descrição:</label>
              <textarea
                class="form-control"
                id="descricao"
                v-model="obj.descricao"
                @keyup.enter="login"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <button :style="{ backgroundColor: empresa.cor_site_escura }" class="btn_1 medium mt-1" type="button" @click="enviarDenuncia()">Enviar</button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { alerta, tratamento_requisicao } from "../../utils/util";
import ModalDenuncia from "@/components/ModalDenuncia";
import axios from "axios";
export default {
	components: {
		ModalDenuncia
	},
	data() {
		return {
      isLoading: false,
      empresa: {
        arquivo_logo: '',
        cor_site_escura: '',
        cor_site_media: '',
        cor_site_clara: '',
      },
			showModal: false,
      protocolo: '',
      tipos_denuncia: [
        { tipo:'Assédio Moral', id: 1},
        { tipo:'Assédio Sexual', id: 2},
        { tipo:'Descumprimento de Normas', id: 3},
        { tipo:'Fraude/Corrupção/Suborno', id: 4},
        { tipo:'Outros', id: 5}
      ],
      unidades: [],
      obj: {
        nome_denunciante: '',
        unidades_id: null,
        empresas_id: null,
        tipo_denuncia: null,
        arquivo_denuncia: null,
        descricao: ''
      },
      style_label: {
        color: ''
      },
      subUrl: ''
		};
	},

  created() {
    this.isLoading = true
    let subUrl = window.location.hostname
    this.subUrl = subUrl.split('.')

    axios.get(`show_by_subdominio/${this.subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.empresa = res.data
        this.style_label.color = res.data.cor_site_escura
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  },

  mounted() {
    this.isLoading = true
    axios.get(`index_denunciante/${this.subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.unidades = res.data
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  },

	methods: {
    changeFile(event) {
      this.obj.arquivo_denuncia = event.target.files[0];
    },
    async enviarDenuncia() {
      if(this.unidades.length > 0 && this.obj.unidades_id && this.obj.tipo_denuncia && this.obj.descricao !== ''
      || this.unidades.length === 0 && this.obj.tipo_denuncia && this.obj.descricao !== '') {
        this.isLoading = true

        let objRequest = new FormData();

        objRequest.append('tipo_denuncia', this.obj.tipo_denuncia);
        objRequest.append('descricao', this.obj.descricao);
        objRequest.append('empresas_id', this.empresa.id);

        if (this.unidades.length > 0 )
          objRequest.append('unidades_id', this.obj.unidades_id);

        if (this.obj.nome_denunciante)
          objRequest.append('nome_denunciante', this.obj.nome_denunciante);

        if (this.obj.arquivo_denuncia)
          objRequest.append('arquivo_denuncia', this.obj.arquivo_denuncia);

        await axios.post('denuncias', objRequest)
          .then((res) => {
            this.protocolo = res.data.protocolo
            this.showModal = !this.showModal
            this.isLoading = false
            this.obj = {}
          }, err => {
            this.isLoading = false
            tratamento_requisicao(err)
          })

      } else {
        alerta('warning', 'Atenção', 'Preencha todos os campos');
      }
    }
	}
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
}

main {
  display: flex !important;
  flex: 1;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  padding: 3vh;
}

label {
  display: flex;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 2px;
}

.box_general {
  height: 55vh;
  overflow: auto;
}

.opt_text {
  margin-left: 5px;
  margin-bottom: 0px;
  font-weight: normal;
  color: #999999;
  font-size: 0.9em;
}

#descricao {
  height: 6vh;
}

#p1 {
  color: #ffffff;
  font-size: 5vh;
  font-weight: bold;
  margin-bottom: 2vh;
}

#p2 {
  color: #ffffff;
  font-size: 4.2vh;
  font-weight: normal;
  line-height: 1;
}

@media (max-width: 374px) {
  #p1 {
    font-size: 2rem;
  }

  #p2 {
    font-size: 1.5rem;
  }
}

@media (min-width: 375px) and (max-width: 576px) {
  #p1 {
    font-size: 3.5vh;
  }

  #p2 {
    font-size: 2.5vh;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  #p1 {
    font-size: 4vh;
  }

  #p2 {
    font-size: 3vh;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  #p1 {
    font-size: 4.5vh;
  }

  #p2 {
    font-size: 3.8vh;
  }
}

@media (min-width: 993px) and (max-width: 1200px) {
  #p1 {
    font-size: 4.8vh;
  }

  #p2 {
    font-size: 4vh;
  }
}

@media (max-width: 900px) {
  main {
    flex-direction: column;
    height: auto;
  }
}
</style>